import type { Filters, SnapshotId, StpInstance } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { STPInstanceMembers } from 'components/STPInstanceMembers/STPInstanceMembers';
import { type FC, memo, useMemo } from 'react';
import type { DeviceViewEdgeEntity } from '../deviceViewTypes';
import { getRequestSnapshotId } from '../helpers/getRequestSnapshotId';
import { getTableNameSn } from '../helpers/getTableNameSn';
import { useDeviceViewContextSelectors } from '../model/DeviceViewModel';

interface Props {
  deviceViewEntity: DeviceViewEdgeEntity;
  isolateStpInstances?: boolean;
  nameSuffix: string;
  snapshotId: SnapshotId | null;
  snapshotToCompareId?: SnapshotId | null;
  stpInstances?: StpInstance[];
}

const BareDeviceViewContentStpDetailTabContent: FC<Props> = (props) => {
  const ctxProps = useDeviceViewContextSelectors({
    handlersContainer: prop('handlersContainer'),
    routesWithApiEndpoint: prop('routesWithApiEndpoint'),
  });
  /*
   * Use STP Instance Members component from proxy due to circular dependency
   * Table -> DeviceView -> STPInstanceMembers -> Table
   */
  const staticFilters: Filters = useMemo(
    () => ({
      members: [
        'containsAny',
        [props.deviceViewEntity.sourceSn, props.deviceViewEntity.targetSn],
      ],
    }),
    [props.deviceViewEntity.sourceSn, props.deviceViewEntity.targetSn],
  );

  return (
    <STPInstanceMembers
      isolateStpInstances={props.isolateStpInstances}
      onStpInstanceUpdate={ctxProps.handlersContainer.handleStpInstanceUpdate}
      onStpInstanceIsolate={ctxProps.handlersContainer.handleStpInstanceIsolate}
      snapshotId={getRequestSnapshotId(
        props.deviceViewEntity,
        props.snapshotId,
        props.snapshotToCompareId,
      )}
      staticFilters={staticFilters}
      stpInstances={props.stpInstances}
      tableId={`device_view_stp_${props.nameSuffix}_${
        props.deviceViewEntity.id
      }_${getTableNameSn(props.deviceViewEntity)}`}
    />
  );
};

export const DeviceViewContentStpDetailTabContent = memo(
  BareDeviceViewContentStpDetailTabContent,
);
